var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10V8C20 5.87827 19.1571 3.84344 17.6569 2.34315C16.1566 0.842855 14.1217 0 12 0C9.87827 0 7.84344 0.842855 6.34315 2.34315C4.84285 3.84344 4 5.87827 4 8V10C3.97544 10.61 3.82539 11.2083 3.55922 11.7577C3.29305 12.3071 2.91647 12.7957 2.453 13.193C1.6202 13.9026 1.09858 14.9103 1 16C1 18.5 5.112 20 12 20C18.888 20 23 18.5 23 16C22.9014 14.9103 22.3798 13.9026 21.547 13.193C21.0835 12.7957 20.707 12.3071 20.4408 11.7577C20.1746 11.2083 20.0246 10.61 20 10Z",
    fill: "#F5365C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14453 21.8999C9.33513 22.5079 9.71483 23.0391 10.2283 23.4163C10.7419 23.7935 11.3624 23.9969 11.9995 23.9969C12.6367 23.9969 13.2572 23.7935 13.7707 23.4163C14.2842 23.0391 14.6639 22.5079 14.8545 21.8999C13.9605 21.9659 13.0105 21.9999 11.9995 21.9999C10.9885 21.9999 10.0385 21.9679 9.14453 21.8999Z",
    fill: "#F5365C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f7a1b0760ee2cec5a30a697269fb2594.svg";
export { ForwardRef as ReactComponent };